import FormArchives from '../../DAL/FormArchives'
import {store} from '../reducer'
import { getDocs, getDoc, collection, doc } from 'firebase/firestore'

export default async function getFormFields(form, archiveId) {
  if (!form || !form.id || !archiveId) return

  const sectionIds = form.order || []

  const formArchives = new FormArchives()
  const archiveRef = formArchives.docRef(archiveId)

  const actionsSnap = await getDocs(collection(archiveRef, 'actions'))
  store.dispatch({type: 'actionData', value: actionsSnap.docs.map((d) => ({id: d.id, ...d.data()}))})

  const combined = {}
  for (const sId of sectionIds) {
    const sectionDoc = await getDoc(doc(archiveRef, 'sections', sId))

    const sectionMeta = sectionDoc.exists()
      ? {id: sectionDoc.id, ...sectionDoc.data()}
      : {id: sId}

    const fieldsSnap = await getDocs(collection(archiveRef, 'sections', sId, 'fields'))

    const ff = {}
    fieldsSnap.docs.forEach((d) => {
      ff[d.id] = {id: d.id, ...d.data()}
    })

    combined[sId] = {...sectionMeta, fields: ff}
  }

  store.dispatch({type: 'updateAllSections', value: combined})
}
